import React from 'react';
//import * as cp from '../components';
import * as resources from 'resources';
import Search from 'components/Search';
import Create from 'components/Create';
import InspectionCalendar from 'components/InspectionCalendar';
import UpcomingInspections from 'components/UpcomingInspections';
import ConfirmInspections from 'components/ConfirmInspections';
import Welcome from 'components/Welcome';
import NotFound from 'components/NotFound';
import Privileges from 'lib/constants/privileges';
import BatchUploader from 'components/BatchUploader';
import Report from 'components/Report';
import ReportPhoneLogs from 'components/ReportPhoneLogs';
import Dashboard from 'components/Dashboard';
import QuotePreview from 'components/QuotePreview';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from 'routes/privateRoute';
import setResourceDefaults from 'lib/helpers/setResourceDefaults';
import TimeOffCalendar from 'components/TimeOffCalendar';
import ProductsImport from 'components/ProductsImport';
import QuoteImportCSV from 'components/Quote/Form/QuoteImportCSV';
import NewForm from 'components/NewForm';
import WorkorderResolution from 'components/WorkorderResolution';
import PartDataCatalog from 'components/PartDataCatalog';
import ContractCreate from 'components/ContractCreate';
import UpcomingContractInvoices from 'components/UpcomingContractInvoices';
import UpcomingContractRenewals from 'components/UpcomingContractRenewals';
import ExpiringContracts from 'components/ExpiringContracts';
import ContractInvoiceComparison from 'components/ContractInvoiceComparison';
import ReceivePayment from 'components/ReceivePayment';
import { ContractInvoices, ProjectInvoices, ServiceInvoices } from 'resources/invoiceTypeViews';


function createRouteForResource(resourceConfig, index){
    const { create } = resourceConfig;

    if(!create){
        return null;
    }

    const key = `${create.routeKey}_${index}`;
    return <PrivateRoute exact path={create.appUrl} 
                          component={Create} 
                        customProps={create} 
                         privileges={create.privileges} 
                                key={key} />
}

function readRouteForResource(resourceConfig, index) {
    const { view } = resourceConfig;

    if(!view) {
        return null;
    }

    const key = `${view.routeKey}_${index}`;
    return <PrivateRoute exact path={view.appUrl} 
                            component={view.component} 
                            customProps={view} 
                            privileges={view.privileges} 
                            key={key} />
}

function searchRouteForResource(resourceConfig, index){
    const { search } = resourceConfig;

    if(!search) { 
        return null;
    }

    const key = `${search.routeKey}_${index}`;
    return <PrivateRoute exact path={search.appUrl} 
                            component={Search} 
                            customProps={search} 
                            privileges={search.privileges} 
                            key={key} />
}

function batchRouteForResource(resourceConfig, index){
    const { batch } = resourceConfig;

    if(!batch){
        return null;
    }

    // let batchProps = {
    //     columnsConfig: batch.form,
    //     defaultTemplate: batch.defaultTemplate
    // };

    const key = `${batch.routeKey}_${index}`;
    return <PrivateRoute exact path={batch.appUrl} 
                          component={BatchUploader} 
                        customProps={batch} 
                         privileges={batch.privileges} 
                                key={key} />

}

function getApplicationRoutes() { 


    return <Switch> 
        <PrivateRoute exact path="/"
            component={Welcome} />

        <PrivateRoute path="/inspections/upcoming"
                privileges={[Privileges.LIST_UPCOMING_INSPECTIONS]}
                component={UpcomingInspections} />

        <PrivateRoute path="/inspections/confirmations"
                privileges={[Privileges.READ_INSPECTIONS]}
                component={ConfirmInspections} />

        <PrivateRoute path="/inspections/schedule"
                component={InspectionCalendar} />

        <PrivateRoute path="/employee_time_off/calendar"
                component={TimeOffCalendar} />

        <PrivateRoute path="/preview/quote/:quote_number"
                component={QuotePreview}
                privileges={[Privileges.OPEN_QUOTE_PREVIEW, Privileges.READ_QUOTES]} />

        <PrivateRoute path="/quotes/:quote_id/import"
                component={QuoteImportCSV}
                customProps={{create_url: '/quote_items',
                    columns: [
                    {name: 'Part Number', key: 'product_number'},
                    {name: 'Quantity', key: 'quantity'},
                ]}}
                privileges={[Privileges.CREATE_QUOTES, Privileges.UPDATE_QUOTES]} />

        <PrivateRoute path="/equipment_releases/:release_id/import/parts"
                component={ProductsImport}
                customProps={{type: 'part'}}
                privileges={[Privileges.CREATE_EQUIPMENT_RELEASES, Privileges.UPDATE_EQUIPMENT_RELEASES]} />

        <PrivateRoute path="/equipment_releases/:release_id/import/services"
                component={ProductsImport}
                customProps={{type: 'service'}}
                privileges={[Privileges.CREATE_EQUIPMENT_RELEASES, Privileges.UPDATE_EQUIPMENT_RELEASES]} />

        <PrivateRoute path="/reports/current_week_time_off"
                 component={Report} /> 

         <PrivateRoute path="/dashboards/company"
             component={Dashboard} /> 

         <PrivateRoute path="/reports/phone_logs"
             component={ReportPhoneLogs} />

        <PrivateRoute path="/work_orders/resolution"
            component={WorkorderResolution}
            privileges={[Privileges.CREATE_WORKORDER_RESOLUTIONS]} />

        <PrivateRoute path="/part_data_sheets"
            component={PartDataCatalog}
            privileges={[Privileges.CREATE_PART_DATA_SHEETS]} />

        {/* Intercept New Payment: the QuickBooks-style Receive Payment screen (pick a customer,
            apply the payment across their open invoices) replaces the generic transaction create
            form. Must precede the generic resource create route below (Switch renders the first
            match). Gated by CREATE_TRANSACTIONS, same as the "New Payment" link. */}
        <PrivateRoute exact path="/transactions/new"
            component={ReceivePayment}
            privileges={[Privileges.CREATE_TRANSACTIONS]} />

        {/* Intercept New Contract: pick a contract type first, then prefill the create
            form from its defaults. Must precede the generic resource create route below
            (Switch renders the first match). customProps is the Contracts `create`
            config, forwarded to the underlying Create form once a type is chosen. */}
        <PrivateRoute exact path="/contracts/new"
            component={ContractCreate}
            customProps={setResourceDefaults(resources.Contracts).create}
            privileges={setResourceDefaults(resources.Contracts).create.privileges} />

        {/* Upcoming Invoices preview (Phase 2 of the batch billing engine). Must precede the
            generic /contracts/:contract_number read route below, or the Switch would match it
            as a contract lookup with contract_number='upcoming_invoices'. Superuser-gated,
            same as the RPC it previews (RPC_generateContractInvoices, granted to 0 roles). */}
        <PrivateRoute exact path="/contracts/upcoming_invoices"
            component={UpcomingContractInvoices}
            privileges={[Privileges.ADMIN]} />

        {/* Upcoming Contract Renewals (preview + generate drafts) and Expiring Contracts report.
            Both MUST precede the generic /contracts/:contract_number read route below, or the
            Switch would match them as contract lookups (contract_number='upcoming_renewals' /
            'expiring'). Superuser-gated, same as the RPCs they call (granted to 0 roles). */}
        <PrivateRoute exact path="/contracts/upcoming_renewals"
            component={UpcomingContractRenewals}
            privileges={[Privileges.ADMIN]} />
        <PrivateRoute exact path="/contracts/expiring"
            component={ExpiringContracts}
            privileges={[Privileges.ADMIN]} />
        <PrivateRoute exact path="/contracts/invoice_comparison"
            component={ContractInvoiceComparison}
            privileges={[Privileges.ADMIN]} />

        {/* Per-type Invoices sub-views. Declared explicitly BEFORE the generic
            resource routes because /invoices/<type> would otherwise be matched by
            the generic /invoices/:id read route (id='project'). Same precedence
            reason as /contracts/upcoming_invoices above. */}
        {[ContractInvoices, ProjectInvoices, ServiceInvoices].map((cfg, index) => {
            const search = setResourceDefaults(cfg).search;
            return <PrivateRoute exact path={search.appUrl}
                                 component={Search}
                                 customProps={search}
                                 privileges={search.privileges}
                                 key={`invoice_type_view_${index}`} />
        })}

        {Object.keys(resources).map((r, index) => batchRouteForResource(setResourceDefaults(resources[r]), index)).filter(v => v)}
        {Object.keys(resources).map((r, index) => createRouteForResource(setResourceDefaults(resources[r]), index)).filter(v => v)}
        {Object.keys(resources).map((r, index) => readRouteForResource(setResourceDefaults(resources[r]), index)).filter(v => v)}
        {Object.keys(resources).map((r, index) => searchRouteForResource(setResourceDefaults(resources[r]), index)).filter(v => v)}

        <Route component={NotFound} />
    </Switch>
};

//for testing new forms
         // <PrivateRoute path="/projects/:id"
         //     component={NewForm} 
         //     customProps={setResourceDefaults(resources.Projects).view} 
         //     privileges={setResourceDefaults(resources.Projects).view.privileges} 
         //     key={'83924'} />
         


export default getApplicationRoutes;

        /*


        <PrivateRoute path="/part/:product_number" 
                 component={cp.Part}
                privileges={[Privileges.READ_PARTS]} />

        <PrivateRoute path="/expense/:expense_number"
                component={cp.Expense}
                privileges={[Privileges.READ_EXPENSES]} />

        <PrivateRoute path="/inspection/:id"
                component={cp.Inspection}
                privileges={[Privileges.READ_INSPECTIONS]} />

        <PrivateRoute path="/expense_payout/:batch_id"
                component={cp.ExpensePayout}
                privileges={[Privileges.READ_EXPENSE_PAYOUTS]} />

        <PrivateRoute path="/inspections/schedule"
                component={cp.InspectionSchedule} />

        <PrivateRoute path="/service/:product_number" 
                 component={cp.Service} 
                privileges={[Privileges.READ_SERVICES]} />

        <PrivateRoute path="/inventory_transfer"
                component={cp.InventoryTransfer}
                privileges={[Privileges.TRANSFER_INVENTORY]} />

        <PrivateRoute path="/quote/:quote_number" 
                 component={cp.Quote} 
                privileges={[Privileges.READ_QUOTES]} />

        <PrivateRoute path="/preview/quote/:quote_number" 
                 component={cp.QuotePreview} 
                privileges={[Privileges.OPEN_QUOTE_PREVIEW, Privileges.READ_QUOTES]} />

        <PrivateRoute path="/time_off/event/:id"
                privileges={[Privileges.READ_EMPLOYEE_TIME_OFF]}
                component={cp.TimeOffEvent} />

        <PrivateRoute path="/time_off/employee/:id"
                privileges={[Privileges.READ_EMPLOYEE_TIME_OFF]}
                component={cp.TimeOff} />

        <PrivateRoute path="/time_used_reports"
                privileges={[Privileges.SEARCH_USED_TIME_OFF]}
                component={cp.TimeUsedReport} />


        <PrivateRoute path="/new/parts" 
                 component={cp.PartsUploader}
                privileges={[Privileges.CREATE_BATCH_PARTS]} />

        <PrivateRoute path="/new/services" 
                 component={cp.ServicesUploader}
                privileges={[Privileges.CREATE_BATCH_SERVICES]} />
        */
